import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceSelectorComponent } from '../../device-selector.component';

@Component({
  selector: 'app-screen-recorder-options',
  imports: [DeviceSelectorComponent, MatButtonModule, MatIconModule, TranslateModule],
  template: `
    <div class="custom-context-menu-wrapper d-flex flex-column gap-2 mb-1 p-2 pt-3">
      <app-device-selector [kind]="'audioinput'" [label]="'DeviceSelector.MicrophoneLabel'" (selectionChange)="onMicrophoneSelected($event)"> </app-device-selector>
      <button mat-flat-button color="warn" (click)="start.emit(selectedMicrophoneId())" [disabled]="!selectedMicrophoneId()">
        <mat-icon>radio_button_checked</mat-icon>
        <span>{{ 'ScreenRecorder.Record' | translate }}</span>
      </button>
    </div>
  `,
  styleUrls: ['../recorders.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreenRecorderOptionsComponent {
  start = output<string>();
  selectedMicrophoneId = signal<string | null>(localStorage.getItem('selectedMicrophone'));

  onMicrophoneSelected(deviceId: string): void {
    this.selectedMicrophoneId.set(deviceId);
  }
}
